module.exports = __webpack_public_path__ + "static/img/swfzpt-bg.cded054.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/swfzpt-bg.png
// module id = RyuZ
// module chunks = 96